import React from 'react'
import logo from "../Files/IBG Logo without background.svg";

interface Props { }

function Load(props: Props) {
    const { } = props

    return (
        <div className='loading'>
            <center><img width={"50%"} className='img-loading'src={logo} alt=""  /></center>
        </div>
    )
}

export default Load
